import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'mars-join-suppliers-network',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './join-suppliers-network.component.html',
  styleUrl: './join-suppliers-network.component.scss',
})
export class JoinSuppliersNetworkComponent {}
